import React from 'react';
import AppHeader from '../../components/Header/Header';
import AppLayout from '../../components/layout';
import BannerSection from '../../components/ui/BannerSection';
import InternacionalMenu from '../../components/ui/InternacionalMenu';
import SectionHeading from '../../components/SectionHeading';
import BreadcrumbNav from '../../components/ui/BreadcrumbNav';

const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Internacional' },
    { label: 'Alojamento' }
];

function Alojamento() {
    return (
         <div>
        <header id='header'>
        <AppHeader />
      </header>
      <BannerSection
        title="Residência Estudantil"
        subtitle="Bem-vindo ao Instituto Superior Politécnico Atlântida"
        description={`Aqui você encontrará informações sobre as opções de alojamento disponíveis para estudantes, garantindo conforto e segurança durante sua jornada acadêmica.`}
        backgroundImage={require('../../assets/BannerInsternacional.jpg')} 
        backgroundId="instituition-Banner"
        />
        <BreadcrumbNav items={caminho} />  
        <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
            <div className="row flex-row-reverse">
            <InternacionalMenu />
            <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
            <br />
            <div className="details-magazine">
                <p className="f-reg f-20">
                     <SectionHeading title="Alojamento  " />
                      O Instituto Superior Politécnica Atlântida (ISP-Atlântida) oferece uma experiência confortável e segura para estudantes que buscam praticidade e proximidade com o campus. Localizado em áreas estratégicas, nossas residências estudantis possuem infraestrutura moderna e acessível, proporcionando um ambiente ideal para o convívio acadêmico e pessoal.
                    <br />
                </p>
                <p className="f-reg f-20">
                    <SectionHeading title="Alojamento para o curso de Línguas " />
                    <b className='text-success'>CASA DE FAMILIA</b><br />
                    <b className='text-gray-500'>Preçario:</b> 350 € <br />
                    <b className='text-success'>Benefícios:</b> Habitação, Alimentação, Água, Luz, Segurança, Internet ,Transporte.
                     <br /> 
                     <br /> 
                     <b className='text-success'> Habitação sobre tutela da escola</b><br />
                    <b className='text-gray-500'>Preçario:</b> 275 € <br />
                    <b className='text-success'>Benefícios:</b> Habitação, Água ,Luz, Internet, Segurança, Ttransporte.
                    <br />
                    <b style={{color:'#BD4A13'}}>Observação: </b>Alimentação por conta do estudante<br />
                </p>
                <p className="f-reg f-20">
                    <SectionHeading title="Alojamento Para Licenciatura " />
                    <b className='text-success'>Habitação sobre tutela da escola</b><br />
                    <b className='text-gray-500'>Preçario:</b> 275 € <br />
                    <b className='text-success'>Benefícios:</b> Habitação, Alimentação, Água, Luz, Segurança, Internet ,Transporte. <br />
                    <b style={{color:'#BD4A13'}}>Observação: </b>Alimentação por conta do estudante<br />
                     <br /> 
                    <br />
                </p>
                </div>
                <br /><br />
            </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
        </main>
        <AppLayout />
        </div>
    );
}

export default Alojamento;